var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutList",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("h1", [_vm._v("Users")]),
          _vm._v(" "),
          _vm.can("createUsers")
            ? _c(
                "router-link",
                {
                  staticClass: "btn btn--primary",
                  attrs: { to: "/users/create" },
                },
                [_vm._v("Users Setup")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "filters" },
        [
          _c("FormControlSector", {
            attrs: {
              name: "sectors",
              multiple: true,
              "include-ancestors": false,
            },
            model: {
              value: _vm.filters.sectors,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "sectors", $$v)
              },
              expression: "filters.sectors",
            },
          }),
          _vm._v(" "),
          _c("FormControlMember", {
            attrs: { name: "member", placeholder: "Select..." },
            model: {
              value: _vm.filters.member,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "member", $$v)
              },
              expression: "filters.member",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form__group search",
          attrs: { slot: "search" },
          slot: "search",
        },
        [
          _c(
            "label",
            { staticClass: "form__label", attrs: { for: "local-search" } },
            [_vm._v("Search Users")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filters.query,
                expression: "filters.query",
              },
            ],
            staticClass: "form__control search",
            attrs: {
              id: "local-search",
              type: "search",
              placeholder: "Search Users...",
            },
            domProps: { value: _vm.filters.query },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.filters, "query", $event.target.value)
              },
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "vue-tabs",
        { ref: "tabs", on: { "tab-change": _vm.onTabChange } },
        [
          _c(
            "v-tab",
            { attrs: { id: "all", title: "All Users" } },
            [
              _c("ListUsers", {
                ref: "all",
                attrs: { "load-on-start": false, filters: _vm.filters },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "inactive", title: "Never Active" } },
            [
              _c("ListUsers", {
                ref: "inactive",
                attrs: {
                  "inactive-only": true,
                  "load-on-start": false,
                  filters: _vm.filters,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "suspended", title: "Suspended Users" } },
            [
              _c("ListUsers", {
                ref: "suspended",
                attrs: {
                  "suspended-only": true,
                  "load-on-start": false,
                  filters: _vm.filters,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }